<template>
  <div class="p-grid">
		<div class="p-col-12">
			<div class="card p-shadow-1">
				<h5>Editar Funcionário</h5>
                <hr>
				<TabView @tab-change="selecionarTab">					
					<TabPanel header="Funcionário" class="p-mt-3">
						<Panel header="Dados do Funcionário">
							<div class="p-grid">
								<div class="p-col-fixed" style="width:150px;" id="divImagem">
									<div style="width: 130px; height: 128px;" class="p-mb-2" id="divFoto">
										<img src="" alt="Foto Perfil" ref="imgFotoPerfil" style="width: 100%; height: 100%; object-fit: cover;"/>
									</div>
									<Button icon="pi pi-upload" class="p-button-rounded p-button-primary p-mr-2" title="Selecionar foto..." @click="uploadImagem"/>
									<Button icon="pi pi-video" class="p-button-rounded p-button-primary p-mr-2" title="Foto da WebCam" @click="exibirFormWebCam"/>							
									<Button icon="pi pi-trash" class="p-button-rounded p-button-danger" title="Excluir" @click="limparFotoPerfil"/>
								</div>
								<div class="p-col">	
									<div class="p-fluid p-formgrid p-grid">
										<div class="p-field p-col-12 p-md-6">
											<label for="nome">Nome</label>
											<InputText id="nome" v-model="funcionario.nome" required="true" autocomplete="off" maxlength="50"/>
											<small class="p-invalid" v-if="enviandoForm && !funcionario.nome">Informe o nome</small>
										</div>
										<div class="p-field p-col-12 p-md-6">
											<label for="nomeCurto">Nome reduzido</label>
											<InputText id="nomeCurto" v-model.trim="funcionario.nomeCurto" autocomplete="off" maxlength="12"/>
										</div>
										<div class="p-field p-col-12 p-md-3">
											<label for="dataNascimento">Data de nascimento</label>
											<Calendar id="dataNascimento" v-model="funcionario.dataNascimento" :showIcon="true" :manualInput="false" dateFormat="dd/mm/yy"
												:monthNavigator="true" :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR"/>									
										</div>
										<div class="p-field p-col-12 p-md-3">
											<label for="pis">PIS</label>
											<InputText id="pis" v-model.trim="funcionario.pis"
											placeholder="____._____.__-_" required="true" 											
											autocomplete="off" maxlength="15"  
											@keyup="formatarPis"/>
											<small class="p-invalid" v-if="enviandoForm && !funcionario.pis">Informe o pis</small>
										</div>
										<div class="p-field p-col-12 p-md-3">
											<label>CPF</label>
											<InputMask v-model.trim="funcionario.cpf" mask="999.999.999-99" placeholder="___.___.___-__" required="true" 
											autocomplete="off" maxlength="14"/>
											<small class="p-invalid" v-if="enviandoForm && !funcionario.cpf">Informe o cpf</small>
										</div>
										<div class="p-field p-col-12 p-md-3">
											<label>E-mail</label>
											<InputText v-model="funcionario.email" autocomplete="off" maxlength="50"/>							
										</div>							
									</div>
								</div>
							</div>
						</Panel>
						<Panel header="Relação com a Empresa" class="p-mt-3 p-mb-3">
							<div class="p-fluid p-formgrid p-grid">
								<div class="p-field p-col-12 p-md-12">
									<label>Empresa</label>
									<InputText v-model="cnpj.cnpjNome" readonly/>
								</div> 							
							</div>
							<div class="p-fluid p-formgrid p-grid">						
								<div class="p-field p-col-12 p-md-4">
									<label for="cracha">Crachá</label>
									<InputText id="cracha" v-model="funcionario.cracha" maxlength="14"/>	
									<small class="p-invalid" v-if="enviandoForm && !funcionario.cracha">Informe o craché</small>						
								</div>
								<div class="p-field p-col-12 p-md-4">
									<label for="registro">Registro</label>
									<InputText id="registro" v-model.trim="funcionario.registro" required="true" autocomplete="off" maxlength="20"/>
									<small class="p-invalid" v-if="enviandoForm && !funcionario.registro">Informe o registro</small>
								</div>
								<div class="p-field p-col-12 p-md-4">
									<label for="dataAdmissao">Data de admissão</label>
									<Calendar id="dataAdmissao" v-model="funcionario.dataAdmissao" :showIcon="true" :manualInput="false" required="true" dateFormat="dd/mm/yy" 
									:monthNavigator="true" :yearNavigator="true" :yearRange="rangeData" :locale="localeCalendarBR"/>									
								</div>
							</div>
							<div class="p-fluid p-formgrid p-grid">						
								<div class="p-field p-col-12 p-md-4">
									<label>Status</label>
									<InputText :value="funcionario.ativo ? 'Ativo' : 'Inativo'" readonly/>						
								</div>
								<div class="p-field p-col-12 p-md-4">
									<label>Situação</label>
									<InputText v-model="motivoAfastamento.descricao" readonly/>								
								</div>
								<div class="p-field p-col-12 p-md-4">
									<label>Data de demissão</label>
									<Calendar v-model="funcionario.dataDemissao" :showIcon="true" :showButtonBar="true" :manualInput="false" 
										dateFormat="dd/mm/yy" :locale="localeCalendarBR"/>								
								</div>
							</div>
							<div class="p-fluid p-formgrid p-grid">						
								<div class="p-field p-col-12 p-md-6">
									<label>Cargo</label>
									<InputText v-model="cargo.nome" readonly/>							
								</div>
								<div class="p-field p-col-12 p-md-6">
									<label for="centroCusto">Centro de custo</label>
									<Dropdown id="centroCusto" v-model.number="idCentroCustoSelecionado" :filter="true" 
										:options="centrosCustos" optionLabel="nome" optionValue="id" 
										dataKey="keyRefId" required="true" placeholder="Selecione"/>	
									<small class="p-invalid" v-if="enviandoForm && !idCentroCustoSelecionado">Selecione um centro de custo</small>
								</div>					
							</div>
							<div class="p-fluid p-formgrid p-grid">						
								<div class="p-field p-col-12 p-md-6">
									<label>Escala de horários</label>
									<InputText v-model="contrato.descricao" readonly/>													
								</div>
								<div class="p-field p-col-12 p-md-6">
									<label>Senha para ponto via teclado</label>
									<Password :feedback="false" v-model.trim="funcionario.senhaTecladoSemBio" autocomplete="off" maxlength="4" @keyup="validarValor"/>	
								</div>					
							</div>
							<div class="p-fluid p-formgrid p-grid">	
								<div class="p-field p-col-12 p-md-4">
									<label for="city1">Dupla verificação</label>
									<div class="p-field-checkbox">							
										<Checkbox v-model="funcionario.duplaVerificacao" :binary="true"/>							
									</div>
								</div>
							</div>
						</Panel>
						<Button label="Fechar" class="p-button-secondary" icon="pi pi-times" @click="cancelar"/>
						<Button label="Salvar" class="p-ml-2" icon="pi pi-check" @click="salvar"/>
					</TabPanel>
					<TabPanel header="Histórico de Escalas de Horários" class="p-mt-3">
						<HistoricoEscalas :escalasHorarios="dadosGerais.funcioContratos" :funcionario="funcionario" :cnpj="cnpj" :callback="buscar"/>
					</TabPanel>
					<TabPanel header="Histórico de Cargos" class="p-mt-3">
						<HistoricoCargos :historicoCargos="dadosGerais.funcioCargos" :funcionario="funcionario" :callback="buscar"/>
					</TabPanel>
					<TabPanel header="Histórico de Afastamentos" class="p-mt-3">
						<HistoricoAfastamentos ref="formHistoricoAfastamentos" :afastamentos="dadosGerais.afastamentos"/>
					</TabPanel>
				</TabView>
			</div>
		</div>

		<Dialog :visible.sync="exibirDialogWebCamFoto" header="WebCam" :modal="true" @hide="desligarWebCam">			
			<WebCam ref="cam" :controlarBotaoSalvar="controlarBotaoSalvar"/>
			<template #footer>
				<Button label="Cancelar" icon="pi pi-times" class="p-button-secondary" @click="desligarWebCam"/>
				<Button label="Salvar" icon="pi pi-check" @click="capturarImagem" :disabled="bloquerSalvarImagem"/>
			</template>
		</Dialog>

		<form id="formUploadImagem"><input type="file" id="inputFileImagemFoto" style="opacity: 0" v-show="false"></form>
  </div>
</template>

<script>
import WebCam from '@/components/util/WebCam.vue';
import RedimensionaImagem from '@/plugins/redimensionaImagem/RedimensionaImagem.js';
import HistoricoEscalas from '@/components/pages/cadastro/funcionarios/HistoricoEscalas.vue';
import HistoricoCargos from '@/components/pages/cadastro/funcionarios/HistoricoCargos.vue';
import HistoricoAfastamentos from '@/components/pages/cadastro/funcionarios/HistoricoAfastamentos.vue';
import FuncionarioService from '@/service/FuncionarioService';
import AfastamentoService from '@/service/AfastamentoService';
import Funcionario from '@/model/Funcionario';
import { exibirMensagem, exibirMensagemSis, localeCalendarBR, FOTO_PERFIL_PADRAO } from '@/global';
import { mapGetters } from 'vuex';

export default {	
	redimensionaImagem: null,
	cargoService: null,
	afastamentoService: null,
	funcionarioService: null,
	props: ['id'],
	data() {
		return {
			base64FotoPerfil: '',
			fotoPerfil: FOTO_PERFIL_PADRAO,						
			rangeData: '',			
			exibirDialogWebCamFoto: false,
			enviandoForm: false,		
			idCentroCustoSelecionado: null,
			centrosCustos: [],
			funcionario: new Funcionario(),		
			contrato: {},
			cargo: {},
			centroCusto: {},
			cnpj: {},
			dadosGerais: {},
			motivoAfastamento: {},
			historicoAfastamentoCarregado: false,
			bloquerSalvarImagem: true,
			localeCalendarBR: localeCalendarBR
		}
	},
	methods: {
		...mapGetters('sessao', ['getDadosRequisicao']),
		salvar() {
			this.enviandoForm = true;
			let funcionario = {...this.funcionario};
			if(!funcionario.nome || !funcionario.pis || !funcionario.cpf || !funcionario.cracha
				|| !funcionario.registro || !this.idCentroCustoSelecionado) {
				return;
			}			
			let centroCusto = null;
			for(let i = 0; i < this.centrosCustos.length; i++) {
				if(this.idCentroCustoSelecionado == this.centrosCustos[i].id) {
					centroCusto = {...this.centrosCustos[i]};				
					break;
				}
			}			
			funcionario.pis = this.funcionario.pis.replace(/\D/gim, '');
			funcionario.cpf = this.funcionario.cpf.replace(/\D/gim, '');
			funcionario.dataNascimento = this.formatarData(funcionario.dataNascimento);
			funcionario.dataCadastro = this.formatarData(funcionario.dataCadastro);
			funcionario.dataFinal = this.formatarData(funcionario.dataFinal);
			funcionario.dataAdmissao = this.formatarData(funcionario.dataAdmissao);
			funcionario.dataDemissao = this.formatarData(funcionario.dataDemissao);
			funcionario.dataAtivacao = this.formatarData(funcionario.dataAtivacao);
			let requisicao = {
				motivoAfastamento: {...this.motivoAfastamento},
				cnpj: {...this.cnpj},
				funcionario: funcionario,			
				centroCusto: centroCusto,			
				base64FotoPerfil: this.base64FotoPerfil,
				usuarioRequisicao: {...this.getDadosRequisicao()},
			};
            this.funcionarioService.alterar(requisicao)
				.then(resp => {
					exibirMensagem(this, resp);				  
					this.buscar();   
                })
                .catch(erro => {					
					this.enviandoForm = false;
					exibirMensagem(this, erro)
				});
		},		
		buscar() {
			let ativo = false;
			if(this.$route.query.at) {
				ativo = this.$route.query.at == 'true' ? true : false;
			}			
			let idFuncionario = null;
			if(this.funcionario.id != null) {
				idFuncionario = this.funcionario.id;
			} else {
				idFuncionario = this.id;
			}
			let requisicao = {
				ativo: ativo,
				idFuncionario: idFuncionario,                   
				usuarioRequisicao: {...this.getDadosRequisicao()}
			};               
			this.funcionarioService.buscar(requisicao)
				.then(resp => {		
					this.dadosGerais = resp.data;
					this.funcionario = this.dadosGerais.funcionario;
					this.formatarPis();	
					if(!this.funcionario.fotoPerfil) {
						this.$refs.imgFotoPerfil.src = FOTO_PERFIL_PADRAO + '?time=' + Date.now();
					} else {
						this.$refs.imgFotoPerfil.src = this.funcionario.fotoPerfil + '?time=' + Date.now();	
					}					
					this.cnpj = this.dadosGerais.cnpj;			
					let encontrouCargo = false;		
					for(let i = 0; i < this.dadosGerais.funcioCargos.length; i++) {
						if(this.dadosGerais.funcioCargos[i].dataFinal == null) {
							this.cargo = this.dadosGerais.funcioCargos[i].cargo;
							encontrouCargo = true;
							break;
						}
					}					
					if(!encontrouCargo && this.dadosGerais.funcioCargos.length > 0) {
						this.cargo = this.dadosGerais.funcioCargos[this.dadosGerais.funcioCargos.length-1].cargo;
					}
					let encontrouContrato = false;		
					let funcioContratoAtual = null;
					for(let i = 0; i < this.dadosGerais.funcioContratos.length; i++) {
						if(this.dadosGerais.funcioContratos[i].dataFinal == null) {
							funcioContratoAtual = {...this.dadosGerais.funcioContratos[i]};
							this.contrato = funcioContratoAtual.contrato;							
							this.dadosGerais.funcioContratos.splice(i,1);
							encontrouContrato = true;
							break;
						}
					}
					this.dadosGerais.funcioContratos.sort(function(fcc1, fcc2) {						
						if(fcc1.id < fcc2.id) {
							return 1;
						} else if(fcc1.id > fcc2.id) {
							return -1;
						}
						return 0;
					});
					if(!encontrouContrato && this.dadosGerais.funcioContratos.length > 0) {
						funcioContratoAtual = {...this.dadosGerais.funcioContratos[this.dadosGerais.funcioContratos.length - 1]};
						this.contrato = funcioContratoAtual.contrato;							
						this.dadosGerais.funcioContratos.splice(this.dadosGerais.funcioContratos.length - 1,1);
					}
					this.dadosGerais['afastamentos'] = [];
					this.dadosGerais.funcioContratos.splice(0,0, funcioContratoAtual);
					this.centrosCustos = this.dadosGerais.centrosCustos;
					let dataKey = 1;               
					this.centrosCustos.forEach(ct => {
						ct['keyRefId'] = dataKey++;
					});
					this.centroCusto = this.dadosGerais.centroCusto;
					this.idCentroCustoSelecionado = this.centroCusto.id;
					this.motivoAfastamento = this.dadosGerais.motivoAfastamento;
				})
				.catch(erro => {exibirMensagem(this, erro)});            
        }, 
		selecionarTab(event) {
			if(event.tab.header == 'Histórico de Afastamentos' 
				&& this.dadosGerais.afastamentos.length == 0
				&& !this.historicoAfastamentoCarregado) {
			this.afastamentoService.listarPorFuncionario(this.funcionario.id)
			.then(resp => {
				this.historicoAfastamentoCarregado = true;
				this.dadosGerais.afastamentos = resp.data;
				this.$refs.formHistoricoAfastamentos.carregar(resp.data);
			})
			.catch(erro => {			
				exibirMensagem(this, erro)
			});
		}
		},
		formatarPis() {
			let arrPis = this.funcionario.pis.replace(/\D/gim, '').split('');			
			let total = arrPis.length;
			let novoPis = '';
			for(let i = 0; i < total; i++) {
				novoPis += arrPis[i];
				// 123. || 1234.
				if((i == 2 && total <= 11) 
					|| (i == 3 && total == 12)) {
					novoPis += '.';									
				}
				// 45678. || 56789.
				if((i == 7 && total <= 11) 
					|| (i == 8 && total == 12)) {
					novoPis += '.';						
				}
				// 00-
				if((i == 9 && total <= 11) 
					|| (i == 10 && total == 12)) {
					novoPis += '-';						
				}	
				this.funcionario.pis = novoPis;				
			}
		},
		alterarFotoPerfil() {
			let requisicao = {
				funcionario: { 
					id: this.funcionario.id, 
					pis: this.funcionario.pis.replace(/[^0-9]+/g, ''), 
					cpf: this.funcionario.cpf.replace(/[^0-9]+/g, '')
				},
				numeroCnpj: this.cnpj.numero,
				idCnpj: this.cnpj.id,
				imagemPerfilBase64: this.base64FotoPerfil
					.replace('data:image/jpeg;base64,', '')
					.replace('data:image/jpg;base64,', '')
			};
			this.funcionarioService.alterarFotoPerfil(requisicao)
			.then(resp => {			
				exibirMensagemSis(this, 'Sucesso', false);
				const imagem = resp.data;
				this.$refs.imgFotoPerfil.src = imagem.link + '/' + imagem.nomeArquivo + '?time=' + Date.now();		
			})
			.catch(erro => {
				exibirMensagem(this, erro);
			}); 			
		},
		excluirFotoPerfil() {
			let requisicao = {
				funcionario: { id: this.funcionario.id }
			};
			this.funcionarioService.excluirFotoPerfil(requisicao)
			.then(resp => {			
				exibirMensagem(this, resp);
				this.base64FotoPerfil = '';
				this.$refs.imgFotoPerfil.src = FOTO_PERFIL_PADRAO;		
			})
			.catch(erro => {
				exibirMensagem(this, erro);
			}); 			
		},
		limparFotoPerfil() {
			if(this.funcionario.fotoPerfil) {
				this.excluirFotoPerfil();
			} else {
				this.base64FotoPerfil = '';
				this.$refs.imgFotoPerfil.src = FOTO_PERFIL_PADRAO;
			}
		},
		exibirFormWebCam() {
			this.exibirDialogWebCamFoto = true;			
		},			
		capturarImagem() {		
			this.$refs.cam.capturarImagemBase64()
			.then((imagem) => {
				this.base64FotoPerfil = imagem.base64;				
				this.desligarWebCam();
				this.alterarFotoPerfil();
			});			
		},
		controlarBotaoSalvar(bloquear) {
			this.bloquerSalvarImagem = bloquear;
		},		
		desligarWebCam() {
			this.exibirDialogWebCamFoto = false;
		},	
		uploadImagem() {
			setTimeout(() => {							
				document.querySelector('#inputFileImagemFoto').click();
				document.querySelector('#inputFileImagemFoto')
					.addEventListener('change', () => {
						let imagem = document.querySelector('#inputFileImagemFoto').files[0];						
						let partesItem = document.querySelector('#inputFileImagemFoto').value.split('\\');   
						let exts = ['jpg', 'jpeg'];
						let nome = partesItem[partesItem.length-1];
						let ext = nome.split('.')[1];  
						if(!exts.includes(ext.toLowerCase())) {
							exibirMensagemSis(this, 'Selecione uma imagem do tipo JPG ou JPEG', true);
							return;
						}
						let url = URL.createObjectURL(imagem);
						let imgTeste = new Image;						
						imgTeste.onload = () => {		
							if(imgTeste.width > 1920 || imgTeste.height > 1080) {
								URL.revokeObjectURL(imgTeste.src);
								exibirMensagemSis(this, 'Tamanho máximo: L 1920 x A 1080', true);
								return;
							}
							// Se a imagem for válida, atualiza a URL e converte para Base64
							this.$refs.imgFotoPerfil.src = url;
							let reader = new FileReader();
							reader.onloadend = () => {
								this.base64FotoPerfil = reader.result
									.replace('data:image/jpeg;base64,', '')
									.replace('data:image/jpg;base64,', '');
								this.alterarFotoPerfil();
							}
							reader.readAsDataURL(imagem);
						}						
						imgTeste.src = url;						
					});
			}, 400);
		},
		formatarData(data) {
			if(!data) {
				return null;
			}
			let strData = null;
			if(data instanceof Date) {
				let dt = data;
				let mes = dt.getMonth();
				let dia = dt.getDate();
				strData = dt.getFullYear() + '-' + ((mes + 1) < 10 ? '0'+(mes+1) : ''+(mes+1)) + '-' + (dia < 10 ? '0' + dia : '' + dia);
			} else {
				let partes = data.split('/');
				strData = partes[2] + '-' + partes[1] + '-' + partes[0];
			}
			return strData;
		},
		validarValor(event) {		
			let valor = this.funcionario.senhaTecladoSemBio.replace(/[^\d]+/g, '');
			this.funcionario.senhaTecladoSemBio = valor; 
			event.target.value = valor;
		},
		cancelar() {
            this.$router.push('/cadastros/funcionarios');
        },
		criarRangeData() {
			let hoje = new Date();
			let anoAtual = hoje.getFullYear();   
			if(hoje.getMonth() == 11) {
				anoAtual++;
			}
			this.rangeData = (anoAtual-90)+':'+anoAtual;     
		},
	},	
	created() {
		this.redimensionaImagem = new RedimensionaImagem();
		this.afastamentoService = new AfastamentoService();
		this.funcionarioService = new FuncionarioService();	
	},
	mounted() {        
		this.buscar();		
		this.criarRangeData();	
	},
	components: {
		'WebCam': WebCam,
		'HistoricoEscalas': HistoricoEscalas,
		'HistoricoCargos': HistoricoCargos,
		'HistoricoAfastamentos': HistoricoAfastamentos,
	}
}
</script>

<style>

</style>